module.exports = __webpack_public_path__ + "static/media/wi-fi.7d87c3fa.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/how-it-works-requirements/wi-fi.svg
// module id = 233
// module chunks = 0